import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { throwError } from 'rxjs';
import { AuthService } from '../core/auth.service';
import { PostService } from '../core/post.service';

@Component({
  selector: 'app-create-post',
  templateUrl: './create-post.component.html',
  styleUrls: ['./create-post.component.scss']
})
export class CreatePostComponent implements OnInit {

  message: string = '';
  public date: string = '';
  link: string;

  form: FormGroup = this.fb.group({
    customer: [''],
    customerCode:[''],
    fromLocation: [''],
    toLocation: [''],
    concreteQuality: [''],
    concreteQuantity: [''],
    phoneNumber: [''],
    time: [''],
    licenseNumbers:[''],
    comment: ['']
  })

  licensePlate: string[] = [];
  public chosenLicensePlate: string[] = [];

  constructor(private fb: FormBuilder,
    private authService: AuthService,
    private postService: PostService,
    private router: Router,
    private route: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    this.date = this.route.snapshot.paramMap.get('date');
    this.postService.getLicensePlates().subscribe(data => {
      this.licensePlate = data;
    }, error => {
      throwError(error);
    });
    this.link = this.date;
  }

  submit(): void {
    if (!this.form.valid) {
      this.message = 'A munkalap rögzítő űrlap nem lett megfelelően kitöltve!';
      return;
    }
    this.postService.create(this.form.value.concreteQuality, this.form.value.concreteQuantity, this.form.value.customer, this.form.value.customerCode, this.form.value.fromLocation, this.form.value.toLocation, this.form.value.phoneNumber, this.authService.getUserName() || '', this.date, this.form.value.time, this.chosenLicensePlate, this.form.value.comment).subscribe(success => {
      if (success) {
        this.router.navigate(['/day', this.date]);
      }
    }, error => {
      throwError(error);
    });

  }

  backToDay(): void {
    this.router.navigate(['/day', this.link]);
  }


}
